import { JobType } from "@repo/db/client";
import { type ColorName, type IconName } from "@repo/ui";

export const jobTypeMeta: Record<
	JobType,
	{
		icon: IconName;
		backgroundColor: ColorName;
		textColor: ColorName;
		borderColor: ColorName;
		label: string;
	}
> = {
	[JobType.Test]: {
		icon: "Sparkles",
		backgroundColor: "sand3",
		textColor: "sand11",
		borderColor: "sand7",
		label: "Running test task",
	},
	[JobType.ReferralPriorAuth]: {
		icon: "CircleCheckBig",
		backgroundColor: "amber3",
		textColor: "amber11",
		borderColor: "amber7",
		label: "Processing prior auth",
	},
	[JobType.PullOpenReferrals]: {
		icon: "Inbox",
		backgroundColor: "blue3",
		textColor: "blue11",
		borderColor: "blue7",
		label: "Pulling referrals",
	},
	[JobType.AttachRecordsSendReferral]: {
		icon: "ArrowBigRightDash",
		backgroundColor: "blue3",
		textColor: "blue11",
		borderColor: "blue7",
		label: "Sending referral",
	},
	[JobType.CheckEligibility]: {
		icon: "ShieldCheck",
		backgroundColor: "green3",
		textColor: "green11",
		borderColor: "green7",
		label: "Checking eligibility",
	},
	[JobType.SearchProviders]: {
		icon: "Search",
		backgroundColor: "accent3",
		textColor: "accent11",
		borderColor: "accent7",
		label: "Searching providers",
	},
	[JobType.CallProviders]: {
		icon: "PhoneCall",
		backgroundColor: "blue3",
		textColor: "blue11",
		borderColor: "blue7",
		label: "Calling providers",
	},
	[JobType.AgentNextStep]: {
		icon: "Bot",
		backgroundColor: "indigo3",
		textColor: "indigo11",
		borderColor: "indigo7",
		label: "Agent processing",
	},
	[JobType.SendSpruceMessage]: {
		icon: "MessageSquare",
		backgroundColor: "blue3",
		textColor: "blue11",
		borderColor: "blue7",
		label: "Sending message to patient",
	},
	[JobType.RecordPatientConsent]: {
		icon: "ClipboardCheck",
		backgroundColor: "green3",
		textColor: "green11",
		borderColor: "green7",
		label: "Recording consent in Athena",
	},
};
